import request from '@/utils/request';

/**
 * 提现记录
 * @param params 参数
 */
export const getDrawsList = (params: any): Promise<any> =>
  request({
    url: '/api/v1/omc/share/draws',
    method: 'get',
    params,
  });
